import { Component, Input, OnInit } from '@angular/core';
import { Card } from '../../../shared/models/card.model';

@Component({
  selector: 'app-card-question',
  templateUrl: './card-question.component.html',
  styleUrls: ['./card-question.component.scss']
})
export class QuestionComponent implements OnInit {

  @Input() card: Card;

  constructor() { }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/remote/card/question/card-question.component.ts